import { Divider } from 'antd';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons/faArrowUpRightFromSquare';
import { getLang } from 'shared/store/selectors/lang.selector';
import { ROUTES, EVENTS, SCHEDULE_EVENT_TYPES } from 'shared/constants';
import analyticsService from 'src/helpers/analytics.service';
import { Modal, Button } from 'src/components/design-system';
import { QrCheckInCard } from './qr-check-in-card';
import { CodeCountdown } from './code-countdown';
import styles from './check-in.module.scss';

export function ShowQrModal({ open, onClose, eventId, eventTitle, isStatic, totpSecret, step }) {
  const lang = useSelector(getLang('EDUCATIONAL_EVENTS'));
  const checkInLang = useSelector(getLang('CHECK_IN_ACTIVE'));
  const createLang = useSelector(getLang('CREATE_EDUCATIONAL_EVENT'));
  const tooltips = useSelector(getLang('ACTION_BUTTON_TOOLTIPS'));

  const handleOpenNewTab = () => {
    analyticsService.track(EVENTS.SCHEDULE.QR_NEW_TAB, {
      type: SCHEDULE_EVENT_TYPES.EDUCATIONAL,
      eventId,
      eventTitle,
    });
    const url = ROUTES.EDUCATIONAL_EVENT_CHECK_IN.replace(':id', eventId);
    window.open(url, '_blank', 'noopener');
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={null}
      footer={null}
      closable={false}
      width={405}
      className={styles.qrModal}>
      <h2 className={styles.qrTitle}>
        {lang.CHECK_IN_TO_EVENT.replace('{title}', eventTitle || '')}
      </h2>
      <p className={styles.qrInstruction}>{checkInLang.SHOW_QR_INSTRUCTION}</p>
      <QrCheckInCard eventId={eventId} isStatic={isStatic} totpSecret={totpSecret} step={step} />
      {!isStatic && step ? <CodeCountdown step={step} /> : null}
      <Divider className={styles.qrDividerSolid} />
      <div className={styles.qrModalActions}>
        <Button type="default" onClick={handleOpenNewTab}>
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
          {tooltips.OPEN_IN_NEW_TAB}
        </Button>
        <Button type="primary" onClick={onClose}>
          {createLang.DONE}
        </Button>
      </div>
    </Modal>
  );
}
